import { Config } from '@leverege/plugin';
import IntercomLoader from "./IntercomLoader.js";
export default {
  id: 'recovr.IntercomInit',
  sort: 100,
  async init(molten) {
    const appId = Config.get('Intercom', 'appId');
    if (appId) {
      try {
        const intercomAttributes = await Config.get('Intercom', 'getInitAttributes', defaultGetInitAttributes)(molten, appId);
        window.intercomSettings = {
          app_id: appId,
          ...intercomAttributes
        };
        // eslint-disable-next-line
        const script = document.createElement('script');
        script.onload = () => {
          window?.Intercom('boot', intercomAttributes);
        };
        // script.setAttribute( 'async', true )
        script.innerHTML = IntercomLoader.getScript(appId);
        document.body.addEventListener('click', () => {
          document.head.appendChild(script);
        }, {
          once: true,
          capture: true
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to set intercom init attributes', err);
      }
    }
  }
};
async function defaultGetInitAttributes(molten, appId) {
  return {
    app_id: appId,
    alignment: 'right',
    hide_default_launcher: true
  };
}